import { Component } from "inferno";
import { RouteComponentProps } from "inferno-router";
import { IRoutePropsWithFetch } from "@utils/routes";
import { InitialFetchRequest } from "@utils/types";

type AdminCommunityCategoriesRouteProps = RouteComponentProps<
  Record<string, never>
>;

export type AdminCommunityCategoriesFetchConfig = IRoutePropsWithFetch<
  Record<string, never>,
  Record<string, never>,
  Record<string, never>
>;

/** Legacy path: redirect into community management categories tab. */
export class AdminCommunityCategories extends Component<
  AdminCommunityCategoriesRouteProps,
  Record<string, never>
> {
  componentWillMount() {
    this.props.history.replace("/admin/communities#categories");
  }

  render() {
    return null;
  }

  static async fetchInitialData(
    _req: InitialFetchRequest,
  ): Promise<Record<string, never>> {
    return {};
  }
}
